// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ReactStately from "react-stately";

let Manager = {};

let Selection = {
  Manager: Manager
};

let Item = {};

let Section = {};

let toArray = (values => [...values]);

let Collection = {
  Item: Item,
  Section: Section,
  toArray: toArray
};

let Select = {};

let RadioGroup = {};

function make(value) {
  if (value.TAG !== "Static") {
    return String(value._0.VAL) + `fr`;
  }
  let match = value._0;
  if (match.NAME === "pct") {
    return String(match.VAL) + `%`;
  } else {
    return match.VAL;
  }
}

let Size = {
  make: make
};

let Resize = {};

let Column = {
  Size: Size,
  Resize: Resize
};

let Header = {};

let Row = {};

let Cell = {};

let Body = {};

let collectionToArray = (values => [...values]);

function useColumnResizeState(prim0, prim1) {
  return ReactStately.useTableColumnResizeState(prim0, prim1);
}

let Table = {
  Column: Column,
  Header: Header,
  Row: Row,
  Cell: Cell,
  Body: Body,
  collectionToArray: collectionToArray,
  useColumnResizeState: useColumnResizeState
};

let DateSegment = {};

let TimeField = {};

let NumberField = {};

let Trigger = {};

let Tooltip = {
  Trigger: Trigger
};

let Toggle = {};

let ToggleGroup = {};

let ComboBox = {};

let ListBox = {};

let TabList = {};

let Trigger$1 = {};

let Overlay = {
  Trigger: Trigger$1
};

let AsyncList = {};

let Data = {
  AsyncList: AsyncList
};

export {
  Selection,
  Collection,
  Select,
  RadioGroup,
  Table,
  DateSegment,
  TimeField,
  NumberField,
  Tooltip,
  Toggle,
  ToggleGroup,
  ComboBox,
  ListBox,
  TabList,
  Overlay,
  Data,
}
/* react-stately Not a pure module */
